import { request } from '@/common/services/request';

const getPayloadData = (payload) => payload?.data || payload || {};

const toProTableResult = (result) => ({
  data: result.data || [],
  success: true,
  total: result.meta?.total || 0,
});

const queryTraceLogs = async (path, params) => {
  const result = await request(path, {
    method: 'GET',
    params,
  });
  return toProTableResult(result);
};

const getTraceAccountData = (data) => ({
  accountType: data.accountType,
  platform: data.platform,
  accountId: data.accountId,
  name: data.name,
});

export async function queryTraceAccounts(params) {
  const result = await request('/api/trace/tenant/accounts', {
    method: 'GET',
    params,
  });
  return toProTableResult(result);
}

export const queryTraceAccountLogs = (params) =>
  queryTraceLogs('/api/trace/tenant/account-logs', params);

export const queryTraceContentLogs = (params) =>
  queryTraceLogs('/api/trace/tenant/content-logs', params);

export const queryTraceCommentLogs = (params) =>
  queryTraceLogs('/api/trace/tenant/comment-logs', params);

export async function createTraceAccount(payload) {
  const data = getPayloadData(payload);
  return request('/api/trace/tenant/accounts', {
    method: 'POST',
    params: {
      organizationId: data.organizationId,
    },
    data: getTraceAccountData(data),
  });
}

export async function updateTraceAccount(payload) {
  const data = getPayloadData(payload);
  return request('/api/trace/tenant/accounts', {
    method: 'PATCH',
    params: {
      organizationId: data.organizationId,
      accountId: data.id,
    },
    data: getTraceAccountData(data),
  });
}

export async function removeTraceAccount(payload) {
  const data = getPayloadData(payload);
  return request('/api/trace/tenant/accounts', {
    method: 'DELETE',
    params: {
      organizationId: data.organizationId,
      accountId: data.id,
    },
  });
}
